<template>
  <paper
    title="General Settings"
    body-class="mt-0"
  >
    <div class="px-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <validation-provider
            #default="{ errors }"
            name="Name"
            rules="required"
            class="w-100"
          >
            <input-field
              name="job_template-name"
              label="Name*"
              label-position="top"
              :error="errors.length ? errors[0] : null"
            >
              <b-form-input
                id="job_template-name"
                v-model="jobTemplate.name"
                placeholder="Enter template name here..."
                :state="errors.length > 0 ? false : null"
              />
            </input-field>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          sm="6"
        >
          <validation-provider
            #default="{ errors }"
            name="Live job template"
            class="w-100"
          >
            <input-field
              name="job_template-liveJobTemplate"
              label="Live Job Template"
              label-position="top"
              :error="errors.length ? errors[0] : null"
            >
              <b-form-checkbox
                id="job_template-liveJobTemplate"
                v-model="jobTemplate.liveJobTemplate"
                name="check-button"
                switch
                stacked
                @change="emitIsLiveJob(jobTemplate.liveJobTemplate)"
              />
            </input-field>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <validation-provider
            #default="{ errors }"
            name="Category"
            class="w-100"
          >
            <input-field
              name="job_template-category"
              label="Category"
              label-position="top"
              :error="errors.length ? errors[0] : null"
            >
              <b-form-input
                id="job_template-category"
                v-model="jobTemplate.category"
                placeholder="Enter template category here.."
                :state="errors.length > 0 ? false : null"
              />
            </input-field>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          sm="6"
        >
          <validation-provider
            #default="{ errors }"
            name="Description"
            class="w-100"
          >
            <input-field
              name="job_template-description"
              label="Description"
              label-position="top"
              :error="errors.length ? errors[0] : null"
            >
              <b-form-input
                id="job_template-category"
                v-model="jobTemplate.description"
                placeholder="Enter template description here.."
                :state="errors.length > 0 ? false : null"
              />
            </input-field>
          </validation-provider>
        </b-col>
      </b-row>
    </div>
  </paper>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import Paper from '@/components/paper/Paper.vue'
import InputField from '@/components/form/InputField.vue'

export default {
  name: 'JobGeneralSettings',
  components: {
    Paper,
    InputField,
    ValidationProvider,
  },
  props: {
    jobTemplate: {
      type: Object,
      default: null,
    },
    fromLiveJobs: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      generalInformation: {
        name: '',
        category: '',
        description: '',
      },
    }
  },
  created() {
    if (this.fromLiveJobs) {
      this.jobTemplate.liveJobTemplate = true
    }
  },
  methods: {
    openInfo(e) {
      this.$emit('openInfo', e)
    },
    emitIsLiveJob(e) {
      this.$emit('liveJobChange', e)
    },
  },
}
</script>

<style></style>
